module.exports = __webpack_public_path__ + "img/compass-drafting.b66b6dec.svg";